import React from 'react';

import { Box, Typography } from '@mui/material';

import { Modal } from 'src/components/common';
import { ModalV2Props } from 'src/types/modalV2';

/**
 * Dead end for a verifier who was invited directly and started the open sign-up instead: the
 * dialog takes no `onClose`, so neither the backdrop nor Escape dismisses it and the only way on
 * is the link in the resent invitation email.
 */
export const VerifierInviteResentModal: React.FC<ModalV2Props<unknown>> = () => {
  return (
    <Modal maxWidth={550} dialogProps={{ open: true }}>
      <Box display="flex" flexDirection="column" gap={2}>
        <Typography variant="h6">The invitation has been resent. Check your inbox.</Typography>
        <Typography variant="body1" color="text.secondary">
          It looks like you were previously invited to Clear Verify. We’ve just resent your
          invitation email. Please complete your registration using the link in that email.
        </Typography>
      </Box>
    </Modal>
  );
};
